import {ColumnsType} from 'antd/lib/table/Table';
import {Dropdown, Menu, Tag} from 'antd';
import {
  AiFillDelete,
  AiFillEdit,
  AiOutlineSafetyCertificate,
} from 'react-icons/ai';
import {useNavigate} from 'react-router-dom';
import IntlMessages from 'src/domain/utility/IntlMessages';
import {ProductRejectionReasonsDto} from 'src/shared/services/product-rejection-reasons/dto/product-rejection-reasons-dto';
import {useIntl} from 'react-intl';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import RowActionsButton from 'src/shared/components/row-actions';

const TableColumn = (
  deleteRejectionReason: Function,
  changeRejectionReasonStatus: Function,
): ColumnsType<any> => {
  const navigate = useNavigate();

  const {messages} = useIntl();

  const {locale}: any = useLocaleContext();

  const editProductRejectionReasonsPage = (item: any) => {
    navigate(`/catalog/product-rejection-reasons/edit/${item.Id}`);
  };

  return [
    {
      title: <IntlMessages id='common.reason' />,
      dataIndex: 'Name',
      key: 'Name',
      render: (value: string, record: ProductRejectionReasonsDto) => {
        return (
          record?.Locales?.find((item) => item.LanguageId === locale.code)
            ?.LocaleValue ?? value
        );
      },
    },
    {
      title: <IntlMessages id='common.status' />,
      dataIndex: 'IsActive',
      width: '20%',
      key: 'IsActive',
      className: 'col-center',
      render: (item: any) => {
        return (
          <Tag
            color={item ? 'green' : 'red'}
            className='ant-tag-disable-pointer'>
            {item
              ? messages['common.active'].toString()
              : messages['common.inactive'].toString()}
          </Tag>
        );
      },
    },
    {
      title: <IntlMessages id='common.Action' />,
      render: (text: string, item: ProductRejectionReasonsDto) => (
        <div>
          <Dropdown
            trigger={['click']}
            overlay={() => (
              <Menu>
                <Menu.Item
                  onClick={() => editProductRejectionReasonsPage(item)}
                  key={'edit'}>
                  <AiFillEdit className='icon-in-action' />
                  <span className='margin-in-action'>
                    <IntlMessages id='common.edit' />
                  </span>
                </Menu.Item>
                <Menu.Item
                  onClick={() => changeRejectionReasonStatus(item?.Id)}>
                  <AiOutlineSafetyCertificate className='icon-in-action' />
                  <span className='margin-in-action'>
                    {item.IsActive ? (
                      <IntlMessages id='common.deactivate' />
                    ) : (
                      <IntlMessages id='common.activate' />
                    )}
                  </span>
                </Menu.Item>
                <Menu.Item
                  onClick={() => deleteRejectionReason(item)}
                  key={'delete'}>
                  <AiFillDelete className='icon-in-action' />
                  <span className='margin-in-action'>
                    <IntlMessages id='common.delete' />
                  </span>
                </Menu.Item>
              </Menu>
            )}
            placement='bottomRight'>
            <RowActionsButton />
          </Dropdown>
        </div>
      ),
      className: 'col-actions',
      width: 80,
    },
  ];
};

export default TableColumn;
